import produtosApi from "@/app/services/produtos";
import axios from '@/app/plugins/Axios';
import { PAGINATION_OPTIONS } from "@/app/vuetifyConfig";

export default {
  namespaced: true,
  state: {
    produto: {},
    produtos: [],
    controle_produtos: [],
    historico: [],
    quantidade_produtos_estoque_minimo: 0,
    pagination: PAGINATION_OPTIONS,
    total_de_registros: 0,
    search: "",
    search_type: "contem",
    total_produtos: 0,
    controle_search: "",
    controle_filtro: {
      estoque_status: "abaixo_minimo",
    },
    controle_selecionados: [],
    proxima_referencia: null,
    variacoes: [],
  },

  mutations: {
    SET_PRODUTOS(state, produtos) {
      state.produtos = produtos;
    },

    SET_PRODUTO(state, produto) {
      state.produto = produto;
    },

    salvar(state, produto) {
      state.produtos.push(produto);
    },

    atualizar(state, produto) {
      let index = state.produtos.findIndex(
        (produto_) => produto_.id == produto.id
      );
      if (index > -1) {
        state.produtos.splice(index, 1, produto);
      }
    },

    ajustar(state, produto) {
      let index = state.produtos.findIndex(
        (produto_) => produto_.id == produto.id
      );
      if (index > -1) {
        state.produtos.splice(index, 1, produto);
      }
    },

    excluir(state, id) {
      let index = state.produtos.findIndex((produto) => produto.id == id);
      if (index > -1) {
        state.produtos.splice(index, 1);
      }
    },

    UNSET_PRODUTO(state) {
      state.produto = {};
    },
    
    SET_QUANTIDADE_PRODUTOS_ESTOQUE_MINIMO(state, quantidade) {
      state.quantidade_produtos_estoque_minimo = quantidade;
    },

    SET_TOTAL(state, total) {
      state.total_de_registros = total;
    },

    SET_PAGE(state, page) {
      state.pagination.page = page;
    },

    SET_SEARCH(state, search) {
      state.search = search;
    },

    UPDATE_PAGINATION(state, options) {
      state.pagination = options;
    },

    SET_CONTROLE_PRODUTOS(state, produtos) {
      state.controle_produtos = produtos;
    },

    SET_CONTROLE_FILTRO(state, controle_filtro) {
      state.controle_filtro = controle_filtro;
    },

    SET_CONTROLE_SELECIONADOS(state, controle_selecionados) {
      state.controle_selecionados = controle_selecionados;
    },

    REMOVER_CONTROLE_SELECIONADO(state, item) {   
      const index =  state.controle_selecionados.findIndex((produto) => produto.id == item.id);
      if (index > -1) {
        state.controle_selecionados.splice(index, 1);
      }
    },
    
    SET_PROXIMA_REFERENCIA(state, proxima_referencia) {
      state.proxima_referencia = proxima_referencia;
    },

    SET_VARIACOES(state, variacoes) {
      state.variacoes = variacoes;
    },
  },

  actions: {
    async listar({ commit, state }) {
      commit("LOADING_ON", null, { root: true });

      const { sortBy, sortDesc, page, itemsPerPage } = state.pagination;

      const parametros = {
        page,
        itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: true,
        searchType: state.search_type,
      };

      if (state.search) {
        parametros.search = state.search;
        parametros.page = 1;
      }

      let response = await produtosApi.listar(parametros);
      commit("SET_PRODUTOS", response.data);
      commit("SET_TOTAL", response.total);
      commit("LOADING_OFF", null, { root: true });
    },

    async abrir({ commit }, id) {
      commit("LOADING_ON", null, { root: true });
      let produto = await produtosApi.abrir(id);
      commit("SET_PRODUTO", produto);
      commit("LOADING_OFF", null, { root: true });
    },

    async salvar({ commit }, produto) {
      let novoproduto = await produtosApi.salvar(produto);
      commit("salvar", novoproduto);
    },

    async atualizar({ commit }, produto) {
      await produtosApi.atualizar(produto);
      commit("atualizar", produto);
    },

    async ajustar({ commit }, produto) {
      produto = await produtosApi.ajustar(produto);
      commit("ajustar", produto);
    },

    async excluir({ commit }, id) {
      await produtosApi.excluir(id);
      commit("excluir", id);
    },

    buscarProdutoPorReferencia({ commit }, referencia) {
      return produtosApi.buscarProdutoPorReferencia(referencia);
    },

    buscarProdutoPorDescricao({ commit }, descricao) {
      return produtosApi.buscarProdutoPorDescricao(descricao);
    },

    async quantidadeProdutosEstoqueMinimo({ commit }) {
      let quantidade = await produtosApi.quantidadeProdutosEstoqueMinimo();
      commit("SET_QUANTIDADE_PRODUTOS_ESTOQUE_MINIMO", quantidade);
    },

    async controleProdutos({ commit, state }) {
      commit("LOADING_ON", null, { root: true });

      let parametros = {}

      if (state.search) {
        parametros.search = state.search;
      }

      parametros = {
        ...parametros,
        ...state.controle_filtro
      }

      let response = await produtosApi.controleProdutos(parametros);
      commit("SET_CONTROLE_PRODUTOS", response);
      commit("LOADING_OFF", null, { root: true });
    },

    async fazerPedidoCompra({ commit }, pedidocompra) {
        await produtosApi.fazerPedidoCompra(pedidocompra);
    },
    
    async proximaReferencia({commit}) {
      const referencia = await produtosApi.proximaReferencia();
      commit("SET_PROXIMA_REFERENCIA", referencia);
    },

    async adicionarVariacao({state}, variacao_id) {
      await produtosApi.adicionarVariacao(state.produto.id, variacao_id);
    },

    async variacoes({commit}, produto_id) {
      const variacoes = await produtosApi.variacoes(produto_id);
      commit("SET_VARIACOES", variacoes);
    },
    
    async removerVariacao({commit, dispatch}, { produto_id, variacao_id }) {
      const variacoes = await produtosApi.removerVariacao(produto_id, variacao_id);
      dispatch('variacoes', produto_id);
    },

    async reprocessarEstoque({commit}, produto_id) {
      await produtosApi.reprocessarEstoque(produto_id);
    }
  },
};
